import React from "react";
import Head from "next/head";

import CareersMain from "@/components/careers/careers-main";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const Careers = () => {
  return (
    <>
      <Head>
        <title>{seoData.CAREERS_JOBS.title}</title>
        <SeoMetaData data={seoData.CAREERS_JOBS} />
      </Head>

      <CareersMain />
    </>
  );
};

export default Careers;
